/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive } from '@angular/core';
/**
 * Suffix to be placed at the end of the form field.
 */
export class MatSuffix {
}
MatSuffix.decorators = [
    { type: Directive, args: [{
                selector: '[matSuffix]',
            },] },
];
/**
 * @nocollapse
 */
MatSuffix.ctorParameters = () => [];
function MatSuffix_tsickle_Closure_declarations() {
    /** @type {?} */
    MatSuffix.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatSuffix.ctorParameters;
}
//# sourceMappingURL=suffix.js.map